import { HttpHeaders } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { environment } from '@src/environments/environment';
import { Customer } from '../model/customer';
import { Customerdeal } from '@src/app/models/customerdeal';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CustomerControlService {

  constructor(private http:HttpClient) { }

 //get deals for customer
 getDeals(customerId,pit){
  const httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  }
  //GET	    /organization/{organizationId}/customer/{customerId}/deal/list/pit/{pitdate}
  return this.http.get<Customerdeal[]>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/customer/'+customerId+'/deal/list/pit/'+pit,httpOptions);

}

  getCustomers(pit:String){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.get<any>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/customer/list/pit/'+pit,httpOptions)
      .pipe(map((res) => Array.isArray(res) ? res : (res?.Items || [])));
  }
  
  createCustomer(customer:Customer){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.post<any>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/customer',JSON.stringify(customer),httpOptions);
  }
  updateCustomer(customer:Customer){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.put<any>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/customer/'+customer.customerId,JSON.stringify(customer),httpOptions)
  }
  deleteCustomer(customer:Customer){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.delete<any>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/customer/'+customer.customerId,httpOptions)
  }
}